// extracted by css-extract-rspack-plugin
export default {"image":"_23a480a3","halfWidth":"_d4b299c1"};